import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user:
      window.localStorage.getItem('user') == null
        ? null
        : JSON.parse(window.localStorage.getItem('user')),
    projectLevelOptions: [{
      value: 1,
      label: '一类'
    }, {
      value: 2,
      label: '二类'
    }, {
      value: 3,
      label: '三类'
    }],
    buildingStructureOptions: [{
      value: 1,
      label: '框架'
    }, {
      value: 2,
      label: '框剪'
    }],
    quotationOptions: [{
      value: 1,
      label: '港式清单'
    }, {
      value: 2,
      label: '国标清单'
    }, {
      value: 3,
      label: '费率'
    }]
  },

  mutations: {
    login (state, user) {
      state.user = user
      window.localStorage.setItem('user', JSON.stringify(user))
    },

    logout (state) {
      state.user = {}
      window.localStorage.removeItem('user')
    }
  }
})
